export const APP_ENVIRONMENT = process.env.REACT_APP_ENVIRONMENT || "";
export const IS_STAGING = APP_ENVIRONMENT === "staging";
const LEGACY_STAGING_FEATURES_ENABLED = (
  IS_STAGING
  && process.env.REACT_APP_LEGACY_STAGING_CAPABILITY === "legacy-roadmap-v1"
);
const IS_LOCAL_DEVELOPMENT = ["local", "development", "dev", "test"]
  .includes(APP_ENVIRONMENT);

const LABS_CAPABILITY_BY_ENVIRONMENT = Object.freeze({
  development: "labs-local-v1",
  test: "labs-test-v1",
  staging: "labs-release-v1",
  production: "labs-release-v1",
});

const LABS_ENABLED = (
  LABS_CAPABILITY_BY_ENVIRONMENT[APP_ENVIRONMENT]
  === (process.env.REACT_APP_LABS_CAPABILITY || "")
);

export const FEATURES = {
  study: LEGACY_STAGING_FEATURES_ENABLED,
  roadmapV2: LEGACY_STAGING_FEATURES_ENABLED,
  learningConcepts: LEGACY_STAGING_FEATURES_ENABLED,
  // Dev Castle is an internal local-development surface. Shared staging is a
  // production-equivalent baseline and does not expose or route to it.
  devCastle: IS_LOCAL_DEVELOPMENT,
  labs: LABS_ENABLED,
};
